export default "__VITE_ASSET__BaqmA_Lx__"